var $ = require( 'jquery' );
import inview from 'jquery-inview/jquery.inview';

$( function() {
	initPipeline();
	calculateSectionsHeight();
});

function initPipeline() {
    const inviewElements = $('.pipeline-chart');
    inviewElements.each( function() {
        const thisInviewElement = $(this);
        const chartWidth = $(this).attr('data-chart-width');
        thisInviewElement.bind( 'inview', function( event, visible ) {
            if ( visible == true ) {
                thisInviewElement.css('width', 100 * parseFloat(chartWidth) + '%');
                thisInviewElement.css('height', 100 * parseFloat(chartWidth) + '%');
            }
        });
    });
}


function calculateSectionsHeight() {
	var sectionPipeline = $('.section-pipeline').innerHeight();
	var sectionPrograms = $('.section-programs').outerHeight();
	var totalHeight = sectionPipeline + sectionPrograms - 370;

	$('.section-pipeline__shape-left, .section-pipeline__shape-right').css({ height: totalHeight + "px"});

}
